import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../common/Header";
import Footer from "../common/Footer";

function Team() {
  let Background = "/images/team.jpg";
  return (
    <div className="teamContainer">
      <Helmet>
        <title>Meet Our Team - Era Salon | Expert Stylists & Nail Technicians | Citrus Heights</title>
        <meta
          name="description"
          content="Meet the expert team at Era Salon in Citrus Heights. Our licensed stylists and nail technicians including Jenny Heng, MYLE, Ann Troung, and Tony provide exceptional hair styling, coloring, nail care, and beauty services."
        />
        <meta
          name="keywords"
          content="Era Salon team, hair stylists Citrus Heights, nail technicians, Jenny Heng, salon staff, licensed beauticians, expert stylists"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://erasalon.com/team" />
        <meta property="og:title" content="Meet Our Team - Era Salon | Expert Stylists & Nail Technicians" />
        <meta property="og:description" content="Meet the expert team at Era Salon in Citrus Heights. Our licensed stylists and nail technicians provide exceptional beauty services." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <div className="fluid-container">
        <div
          className="jumbotron jumbotron-fluid"
          style={{
            backgroundImage: `url(${Background})`,
            backgroundSize: "cover",
            height: "400px",
          }}
        >
          <div className="container">
            <h1 className="display-4 text-center">Our Team</h1>
          </div>
        </div>
        <div className="container">
          <div className="team">
            <div className="row">
              <div className="col-lg-3">
                <div className="teamInfo text-center">
                  <img
                    src="/images/team-jenny.jpg"
                    className="img-thumbnail rounded"
                    alt="Jenny"
                  />
                  <p className="pt-3">
                    <strong>Jenny Heng - Manager</strong>
                  </p>
                  <p>Hair Cut &amp; Color, Waxing</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="teamInfo text-center">
                  <img
                    src="/images/team-myle.jpg"
                    className="img-thumbnail rounded"
                    alt="Myle"
                  />
                  <p className="pt-3">
                    <strong>MYLE - Hair Dresser</strong>
                  </p>
                  <p>Hair Cut - Color</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="teamInfo text-center">
                  <img
                    src="/images/team-ann.jpg"
                    className="img-thumbnail rounded"
                    alt="Ann"
                  />
                  <p className="pt-3">
                    <strong>Ann Troung - Team Member</strong>
                  </p>
                  <p>Nails Care &amp; Skin Care</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="teamInfo text-center">
                  <img
                    src="/images/tony.jpg"
                    className="img-thumbnail rounded"
                    alt="Tony"
                  />
                  <p className="pt-3">
                    <strong>Tony - Team Member</strong>
                  </p>
                  <p>Nails &amp; Pedicutres</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Team;
